import request from '../../utils/request'

export function getParams () {
  return request.get('/business/operationConfig')
}

export function saveParams (data) {
  return request.post('/business/operationConfig/save', data, {
    trim: true
  })
}
